<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack"  v-if="specialInfo.title!=''" :content="'【'+specialInfo.title+'】课时信息详情'"></el-page-header>
			<!-- <el-divider></el-divider> -->
			<div class="row-me row-center margin-top20" >
				<el-collapse class="width100Per" v-model="activeNames" >
					<el-collapse-item title="学员基础信息" name="1" v-if="dataInfo != null">
						<el-descriptions  style="width: 100%;" :column = "4" border>
							<el-descriptions-item label="头像">
								<el-image v-if="dataInfo.avatar == null" class="avatarBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="avatarBox" :src="dataInfo.avatar"></el-image>
							</el-descriptions-item>
							<el-descriptions-item label="生日">{{dataInfo.birthday}}</el-descriptions-item>
							<el-descriptions-item label="性别">{{dataInfo.sex}}</el-descriptions-item>
							<el-descriptions-item label="年龄">{{dataInfo.ageText}}岁</el-descriptions-item>
							
							<el-descriptions-item label="姓名">{{dataInfo.name}} </el-descriptions-item>
							<el-descriptions-item label="手机号">{{dataInfo.phone}}</el-descriptions-item>
							
							<el-descriptions-item label="昵称">{{dataInfo.nickname}}</el-descriptions-item>
							<el-descriptions-item label="年级">{{dataInfo.grade_text}}</el-descriptions-item>
							<el-descriptions-item label="地区">{{dataInfo.area_text}}</el-descriptions-item>
							<el-descriptions-item label="签名">{{dataInfo.signature}}</el-descriptions-item>
						</el-descriptions>
					</el-collapse-item>
					<el-collapse-item title="课程基础信息" name="2" v-if="specialInfo!=null">
						<el-descriptions direction="vertical" style="width: 100%;" :column = "5" border>
							<el-descriptions-item label="课程封面" style="30%">
								<el-image v-if="specialInfo.image == null" class="specialImg" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="specialImg" :src="specialInfo.image"></el-image>
							</el-descriptions-item>
							<el-descriptions-item label="课程名称">{{specialInfo.title}}</el-descriptions-item>
							<el-descriptions-item label="课程分类">{{specialInfo.TcSpecialSubInfo.name}}</el-descriptions-item>
							<el-descriptions-item label="学习人数">{{specialInfo.actual_human}}</el-descriptions-item>
							<el-descriptions-item label="课程时常">{{specialInfo.special_duration}}</el-descriptions-item>
							<el-descriptions-item label="学习进度">
								<br />
								<el-progress v-if="specialInfo.studyRecord != null" :percentage="specialInfo.studyRecord.special_progress"></el-progress>
								<el-progress v-else :percentage="0"></el-progress>
								<br />
							</el-descriptions-item>
							
						</el-descriptions>
					</el-collapse-item>
				</el-collapse>
				
			</div>
			<div class="column-me flex1 overflow-auto margin-top20">
				<div class="flex1 overflow-auto">
					<el-table :data="tableData" :highlight-current-row="false" :show-header="false" v-loading="loading" size="medium" style="width: 100%" height="100%">
						<el-table-column prop="phone" label="课程素材图片" width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-image v-if="scope.row.image == null" class="specialImgBox" :src="require('@/assets/images/user_avatar.png')"></el-image>
								<el-image v-else class="specialImgBox" :src="scope.row.image"></el-image>
							</template>
						</el-table-column>
						<el-table-column prop="nickname" label="课程素材信息"  width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="specialTitle">{{scope.row.title}}</div>
								<div class="specialStudy" v-if="scope.row.studyTaskRecord != null">
									学习状态：{{scope.row.studyTaskRecord.statue == 1 ? '未开始' : (scope.row.studyTaskRecord.statue == 2 ? '学习中' : '已学完')}}
								</div>
								<div class="specialStudy" v-else>学习状态：未开始</div>
								<div class="startTimeBox" v-if="scope.row.studyTaskRecord != null">开始时间：{{scope.row.studyTaskRecord.add_time}}</div>
								<div class="startTimeBox" v-else>开始时间：还未开始</div>
							</template>
						</el-table-column>
						<el-table-column prop="name" label="学习进度" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-progress v-if="scope.row.studyTaskRecord != null" :percentage="scope.row.studyTaskRecord.video_current_progress"></el-progress>
								<el-progress v-else :percentage="0"></el-progress>
							</template>
						</el-table-column>
						<el-table-column prop="sex" label="学习用时"  width="200" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox" v-if="scope.row.studyTaskRecord != null">已学习时长：{{scope.row.studyTaskRecord.video_current_time_text}}</div>
								<div class="startTimeBox" v-else>已学习时长：还未开始</div>
								<div class="startTimeBox" v-if="scope.row.studyTaskRecord != null">总学习时长：{{scope.row.studyTaskRecord.video_duration_text}}</div>
							</template>
						</el-table-column>
						<el-table-column v-if="acctype == 1" prop="sex" label="学习用时"  width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								<div class="startTimeBox"><el-button type="danger" @click="taskStudyInfoChecked(scope.row)" size="small">进度调整</el-button></div>
							</template>
						</el-table-column>
					</el-table>
				</div>

			</div>
		</div>
	</div>
	<!-- 课程素材学习进度调整 -->
	<el-dialog :title="'【'+specialInfo.title+'】-【'+taskStudyProgressTitle+'】进度调整'" v-model="taskStudyProgressState" width="800px" :destroy-on-close="true">
	    <div class="userList column-me">
			<el-progress :percentage="taskStudyInfo.video_current_progress"></el-progress>
			<div class="row-me row-center margin-top20">
				<div class="progress-left-box">进度调整：</div>
				<div class="width500">
					<el-input-number v-model="taskStudyInfo.video_current_progress" :min="0" :max="100" label="描述文字"></el-input-number>
				</div>
			</div>
			<div class="row-me row-center">
				<div class="progress-left-box">开始学习日期：</div>
				<div class="width500">
					<el-date-picker
					    v-model="taskStudyInfo.add_time"
					    type="date"
					    placeholder="选择日期">
					</el-date-picker>
				</div>
			</div>
			<div class="row-me flex-end1 margin-top20">
				<el-button @click="taskStudyProgressClosed()">取消</el-button>
				<el-button @click="taskStudyInfoPost()" type="primary">保存</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import {Plus,Search} from "@element-plus/icons";
export default {
  components: {Plus,Search},
  data() {
    return {
		acctype:null,
		id:0,
		dataInfo:null,
		specialInfo:{
			title:'',
			image:'',
			TcSpecialSubInfo:{
				name:''
			},
			special_duration:'',
			actual_human:0,
			
			
			
		},
		loading:true,
		tableData: [],
		activeNames: [],
		taskStudyProgressState:false,	//课程素材学习进度调整弹窗状态
		taskStudyInfo:null,				//课程素材学习进度信息
		taskStudyProgressTitle:'',
		specialTaskInfo:null,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {
    Search() {
      return Search
    }
  },
  // html加载完成之前
  created() {
	  this.acctype = sessionStorage.getItem('acctype');
	  this.id = this.$route.query.id;
	  this.user_id = this.$route.query.user_id;
	  if(this.id != 0){
	  	this.getStudentInfo();
	  	this.getData();
	  }
  },
  // html加载完成后执行。
  mounted() {
	
	//console.log(this.id);
  },
  // 事件方法执行
  methods: {
		goBack(){
			this.$router.go(-1)
		},
		//table获取用户兑换课程数据
		getData() {
			this.loading = true;
			this.$post('/admin/getSpecialTaskInfo', {
				id: this.id,
				user_id:this.user_id
			}).then((res) => {
				if (res) {
					this.specialInfo = res.data.specialInfo;;
					this.tableData = res.data.taskInfo;
					this.loading = false;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		getStudentInfo(){
			this.$post('/admin/studentInfo', {
				id: this.user_id
			}).then((res) => {
				if (res) {
					//console.log(res.data);
					this.dataInfo = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		taskStudyProgressClosed(){
			this.taskStudyProgressState = false;
		},
		//课程素材学习信息选中赋值
		taskStudyInfoChecked(data){
			//console.log(data);
			this.specialTaskInfo = data;
			this.taskStudyProgressTitle = data.title;
			this.taskImage = data.image;
			if(data.studyTaskRecord == null){
				this.taskStudyInfo = {
					user_id:this.user_id,
					subject_id:this.specialInfo.subjectInfo.tc_subject_id,
					special_id:this.id,
					special_task_id:data.id,
					spe_sub_id:data.TcSpecialSubInfo.id,
					video_duration:data.duration,
					video_current_time:0,
					video_current_progress:0,
					old_video_current_time:0,
					statue:1,
					user_special_record_user_id:this.user_id,
					refund_status:0,
					add_time:''
				}
			}else{
				this.taskStudyInfo = data.studyTaskRecord;
				this.taskStudyInfo.old_video_current_time = data.studyTaskRecord.video_current_time;
			}
			this.taskStudyProgressState = true;		
		},
		//课程素材学习信息进度调整提交
		taskStudyInfoPost(){
			if(this.taskStudyInfo.add_time == ''){
				this.$message.error('请选择开始学习日期')
				return;
			}
			this.taskStudyInfo.video_current_time = Math.round((this.taskStudyInfo.video_duration/100)*this.taskStudyInfo.video_current_progress);
			this.$post('/admin/userTaskStudyInfoPost', this.taskStudyInfo).then((res) => {
				//console.log(res);
				if (res) {
					this.taskStudyProgressState = false;
					this.getData();
				}
			}).catch((error) => {
					console.log(error)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.el-collapse-item__title{
	font-size: 20px !important;
}
.userList {
	height: 100%;
	.avatarBox{
		width: 40px;
		height: 40px;
		border-radius: 20px;
		overflow: hidden;
	}
	.specialImg{
		float: left;
		width: 160px;
		height: auto;
	}
	.specialTitle{
		float: left;
		width: 100%;
		height: 40px;
		text-align: left;
		line-height: 40px;
		font-size: 18px;
		color: #555555;
		// background-color: aquamarine;
	}
	.specialStudy{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 16px;
		color: #555555;
		// background-color: antiquewhite;
	}
	.startTimeBox{
		float: left;
		width: 100%;
		height: 30px;
		text-align: left;
		line-height: 30px;
		font-size: 14px;
		color: #555555;
		// background-color: aquamarine;
	}
	.stemTitle{
		//float: left;
		width: 100% !important;
		font-size: 14px;
		font-weight: bold;
		height: 40px;
		overflow: hidden;
		line-height: 40px;
	}
	.stemClass{
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		height: auto;
		overflow: hidden;
		color: #000000;
		span{
			float: left;
		}
		.setmImage{
			float: left;
			//margin-left: calc(50% - 180px);
			width: 80%;
			height: 225px;
			overflow: hidden;
		}
		.optionClass{
			display: block;
			font-size: 14px;
			font-weight: 500;
			line-height: 30px;
			height: auto;
			width: 100%;
			padding: 0px 10px 0px 0px;
			.optionImageTitle{
				float: left;
				width: 30px;
				line-height: 225px;
				height: 225px;
			}
			
		}
	}
	.stemClass .optionClass .optionImage{
				float: left;
				width: 360px;
				height: 225px;
			}
	.stemClass .optionClass .optionImage .el-image{
		width: 360px;
		height: 225px;
		overflow: hidden;
	}	
	.setmAnswer{
		font-size: 14px;
		line-height: 40px;
		background-color: #f4f4f5;
		color: #909399;
		padding: 0px 20px 0px 20px;
	}
	.setmBrief{
		float: left;
		width: 100%;
		overflow: hidden;
	}
	.setmBrief img{
		width: 500px;
		height: auto;
	}
	
	.specialTaskBox{
		float: left;
		width: 100%;
		height: auto;
	}
	.progress-left-box{
		float: left;
		width: 150px;
		text-align: left;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}
	.progress-box{
		float: left;
		width: 100px;
		height: 30px;
		background-color: #000000;
	}
	
}
</style>
